import { isString } from "../types/isString";
import { isArray } from "../types/isArray";
import { isBoolean } from "../types/isBoolean";

/**
 * Checks if a given value is valid and required.
 *
 * A value is considered valid and required if:
 * - It is not `null` or `undefined` (except for the number `0`).
 * - If it is a string or an array, it must have a length of at least 1.
 *
 * @param value - The value to be checked.
 * @returns `true` if the value is valid and required, `false` otherwise.
 */
export const isValidRequired = (value: unknown): boolean => {
  if (isBoolean(value)) {
    return true;
  }
  if (value === undefined || value === null) {
    return false;
  }
  return !((isString(value) || isArray(value)) && value.length < 1);
};
